module.exports = "/_next/static/images/8524ff5752e98300f5b9ca25952f594a-cajitas-right-desktop.jpg";